import PurchaseService from '@/api/PurchaseService'

// initial state
const state = {
  purchases: [],
  purchase: null,
  nextPoCode: null,
}

// getters
const getters = {
  getPurchases: state => state.purchases,
  getPurchase: state => state.purchase,
  getNextPoCode: state => state.nextPoCode,
  getPurchaseStatus: (state) => (purchase, $t, mixin) => {
    let debtAmount = mixin.getDebtPurchaseAmount(purchase)
    let isPaid = false
    let foundTaskReceipt = false
    let isDoneReceipt = true
    let status = ''
    // end this line if this po has rejected
    if (purchase.status == 'rejected') {
      return {
        message: $t('status.po.rejected'),
        status: 'rejected',
      }
    }
    // end this line if this po is padding
    if (purchase.status == 'padding') {
      return {
        message: $t('status.po.padding'),
        status: 'padding',
      }
    }
    if (purchase.reference.goodsreceipts.length > 0) {
      foundTaskReceipt = true
      for (let i in purchase.reference.goodsreceipts) {
        if (purchase.reference.goodsreceipts[i].status != 'done') {
          isDoneReceipt = false
        }
      }
    }
    if (purchase.reference.payments.length > 0) {
      isPaid = true
      for (let i in purchase.reference.payments) {
        if (purchase.reference.payments[i].status != 'paid') {
          isPaid = false
        }
      }
      if (debtAmount > 0) {
        isPaid = false
      }
    }
    if (foundTaskReceipt) {
      if (!isDoneReceipt && !isPaid) {
        return {
          message: $t('status.po.toreceiveandpay'),
          status: 'uncompleted',
        }
      } else if (!isDoneReceipt) {
        return {
          message: $t('status.po.toreceive'),
          status: 'uncompleted',
        }
      } else if (!isPaid) {
        return {
          message: $t('status.po.topay'),
          status: 'uncompleted',
        }
      }
    } else {
      if (!isPaid) {
        return {
          message: $t('status.po.topay'),
          status: 'uncompleted',
        }
      }
    }
    return {
      message: $t('status.po.completed'),
      status: 'completed',
    }
  },
  getPRStatus: (state) => (pr, po, $t, mixin) => {
    if (pr.status == 'rejected') {
      return {
        message: $t('status.pr.rejected'),
        status: 'rejected',
      }
    }
    if (pr.status == 'padding') {
      return {
        message: $t('status.pr.padding'),
        status: 'padding',
      }
    }
    if (po == null) {
      return {
        message: $t('status.pr.wait_for_po'),
        status: 'padding',
      }
    } else {
      let purchase = po
      let debtAmount = mixin.getDebtPurchaseAmount(purchase)
      let isPaid = false
      let foundTaskReceipt = false
      let isDoneReceipt = true
      let status = ''
      if (purchase.status == 'rejected') {
        return {
          message: $t('status.po.rejected'),
          status: 'rejected',
        }
      }
      if (purchase.status == 'padding') {
        return {
          message: $t('status.po.uncompleted'),
          status: 'uncompleted',
        }
      }
      if (purchase.reference.goodsreceipts.length > 0) {
        foundTaskReceipt = true
        for (let i in purchase.reference.goodsreceipts) {
          if (purchase.reference.goodsreceipts[i].status != 'done') {
            isDoneReceipt = false
          }
        }
      }
      if (purchase.reference.payments.length > 0) {
        isPaid = true
        for (let i in purchase.reference.payments) {
          if (purchase.reference.payments[i].status != 'paid') {
            isPaid = false
          }
        }
        if (debtAmount > 0) {
          isPaid = false
        }
      }
      if (foundTaskReceipt) {
        if (!isDoneReceipt && !isPaid) {
          return {
            message: $t('status.po.uncompleted'),
            status: 'uncompleted',
          }
        } else if (!isDoneReceipt) {
          return {
            message: $t('status.po.uncompleted'),
            status: 'uncompleted',
          }
        } else if (!isPaid) {
          return {
            message: $t('status.po.uncompleted'),
            status: 'uncompleted',
          }
        }
      } else {
        if (!isPaid) {
          return {
            message: $t('status.po.uncompleted'),
            status: 'uncompleted',
          }
        }
      }
      return {
        message: $t('status.pr.completed'),
        status: 'completed',
      }
    }
  },
  getPurchaseInfo: (state) => (po_id) => {
    return state.purchases.find(po => po.po_id == po_id)
  },
}

// mutations
const mutations = {
  setPurchases (state, data) {
    state.purchases = data
  },
  setPurchase (state, data) {
    state.purchase = data
  },
  setNextPoCode (state, data) {
    state.nextPoCode = data
  },
  updatePurchaseStatus (state, data) {
    if (state.purchase) {
      if (state.purchase.po_id == data.po_id) {
        state.purchase.status = data.status
      }
    }
    if (state.purchases.length > 0) {
      state.purchases.map((p, idx) => {
        if (p.po_id == data.po_id) {
          return p.status = data.status
        }
      })
    }
  },
  updatePurchasePaymentStatus (state, data) {
    if (state.purchase) {
      state.purchase.reference.payments.map(payment => {
        if (payment.pe_id == data.pe_id) {
          payment.status = data.status
        }
      })
    }
  },
}

// actions
const actions = {
  async getPurchases ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPurchases') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPurchases')

      let response = await PurchaseService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPurchases')

      result = response.data

      if (result.success) {
        commit('setPurchases', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPurchases ({ commit }) {
    commit('setPurchases', [])
  },
  async getPurchase ({ commit }, params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPurchase') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPurchase')

      let response = await PurchaseService.getSingle(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPurchase')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setPurchase', result.data[0])
        } else {
          // not found data
          this.dispatch('Error', 'Not found data')
        }
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPurchase ({ commit }) {
    commit('setPurchase', null)
  },
  async insertPurchase ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await PurchaseService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextPoCode ({ commit }, params) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextPoCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextPoCode')

      let response = await PurchaseService.getLatestCode(params)

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextPoCode')

      result = response.data

      if (result.success) {
        commit('setNextPoCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deletePurchase ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PurchaseService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updatePurchase ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PurchaseService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updatePurchaseStatus ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PurchaseService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updatePurchaseStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  updatePurchasePaymentStatus ({ commit }, data) {
    commit('updatePurchasePaymentStatus', data)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Purchase.js